/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * See codegen config in .graphqlrc.yml for details
 */

import gql from 'graphql-tag';

import type * as Types from '@sg/graphql-schema';
export type NotificationCategoryFragment = {
  readonly __typename: 'NotificationCategory';
  readonly id: string;
  readonly displayName: string;
  readonly emailSubscribe: boolean;
  readonly pushSubscribe: boolean;
  readonly hasResolved: boolean;
};

export const NotificationCategoryFragmentDoc = gql`
  fragment notificationCategory on NotificationCategory {
    id
    displayName
    emailSubscribe
    pushSubscribe
    hasResolved
    __typename
  }
`;
